import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

class SocketService {
  constructor() {
    this.socket = null;
  }

  connect() {
    if (!this.socket) {
      this.socket = io(SOCKET_URL);
      
      this.socket.on('connect', () => {
        console.log('Socket connected:', this.socket.id);
      });

      this.socket.on('disconnect', () => {
        console.log('Socket disconnected');
      });
    }
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  joinDispatch(dispatchId) {
    if (this.socket) {
      this.socket.emit('join-dispatch', dispatchId);
    }
  }

  leaveDispatch(dispatchId) {
    if (this.socket) {
      this.socket.emit('leave-dispatch', dispatchId);
    }
  }

  sendLocationUpdate(dispatchId, location) {
    if (this.socket) {
      this.socket.emit('location-update', { dispatchId, location });
    }
  }

  onLocationChanged(callback) {
    if (this.socket) {
      this.socket.on('location-changed', callback);
    }
  }

  offLocationChanged() {
    if (this.socket) {
      this.socket.off('location-changed');
    }
  }
}

const socketService = new SocketService();
export default socketService;
